import { render, staticRenderFns } from "./NewClient.vue?vue&type=template&id=e49d3e12"
import script from "./NewClient.vue?vue&type=script&lang=js"
export * from "./NewClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports